import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
} from "reactstrap";
import toast from "react-hot-toast";
import DiscountService from "../../../../services/OrderingServices/DiscountService";
import { useDispatch, useSelector } from "react-redux";
import { fetchDiscountAvailable } from "../../../../slices/DiscountHandle/discountSlice";

const HeaderDiscountDisplay = () => {
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const { data: discounts, loading } = useSelector(
    (state) => state.discounts
  );

  const toggle = () => setDropdownOpen((prev) => !prev);

  useEffect(() => {
    dispatch(fetchDiscountAvailable());
  }, [dispatch]);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await dispatch(fetchDiscountAvailable());
    setIsRefreshing(false);
  };

  // Don't render if loading or empty
  if (loading || discounts.length === 0) return null;

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} className="ms-2">
      <DropdownToggle
        tag="button"
        className="btn btn-success btn-sm d-flex align-items-center gap-2 position-relative"
        style={{
          boxShadow: "0 2px 8px rgba(40, 199, 111, 0.3)",
        }}
      >
        <i className="ri-price-tag-3-line"></i>
        <span className="d-none d-md-inline">
          {discounts.length} Discount{discounts.length > 1 ? "s" : ""}
        </span>
        <Badge
          color="dark"
          pill
          className="position-absolute top-0 start-100 translate-middle"
          style={{ fontSize: "0.65rem" }}
        >
          {discounts.length}
        </Badge>
      </DropdownToggle>

      <DropdownMenu
        end
        className="dropdown-menu-lg p-0"
        style={{
          minWidth: "320px",
          maxHeight: "400px",
          overflowY: "auto",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        }}
      >
        <div className="dropdown-header bg-success-subtle d-flex justify-content-between align-items-center py-3">
          <h6 className="m-0 text-success fw-semibold">
            <i className="ri-discount-percent-line me-2"></i>
            Active Discounts
          </h6>
          <Badge color="success" pill>
            {discounts.length}
          </Badge>
        </div>

        {discounts.map((discount, index) => (
          <React.Fragment key={discount.id}>
            <DropdownItem
              className="py-3 px-3"
              style={{
                cursor: "pointer",
                transition: "background-color 0.2s",
              }}
              onClick={() => {
                toast.success(`Discount: ${discount.name}`, {
                  icon: "🎉",
                  duration: 3000,
                });
              }}
            >
              <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                  <h6 className="mb-1 fw-semibold text-dark">
                    {discount.name}
                  </h6>
                  <p className="text-muted mb-1 small">
                    {discount.description || "Special discount offer"}
                  </p>
                  <div className="d-flex gap-2 flex-wrap">
                    {discount.discountType && (
                      <Badge color="info" className="text-capitalize">
                        {discount.discountType}
                      </Badge>
                    )}
                    {discount.discountFor && (
                      <Badge color="primary" className="text-capitalize">
                        {discount.discountFor}
                      </Badge>
                    )}
                  </div>
                </div>
                <div className="text-end ms-2">
                  <Badge color="success-subtle" className="text-success">
                    <i className="ri-check-line me-1"></i>
                    Active
                  </Badge>
                </div>
              </div>
            </DropdownItem>
            {index < discounts.length - 1 && <DropdownItem divider />}
          </React.Fragment>
        ))}

        <div className="dropdown-footer p-2 border-top bg-light">
          <button
            className="btn btn-sm btn-success w-100 d-flex justify-content-center align-items-center gap-2"
            onClick={handleRefresh}
            disabled={isRefreshing} // disable while loading
          >
            {isRefreshing ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                ></span>
                Loading...
              </>
            ) : (
              <>
                <i className="ri-refresh-line me-1"></i>
                Refresh Discounts
              </>
            )}
          </button>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default HeaderDiscountDisplay;
